'use strict';

const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const GeocodedStatus=require('pulsar-driveplan/dist-es6/domain/geocodedStatus');
const ForecastPersonViewModel=require('../../../../dist-es6/client/viewModels/forecastPersonViewModel');let

CurrentDutyStatusDirective=class CurrentDutyStatusDirective extends BaseControllerBackedDirective{
get templateUrl(){return'/templates/directives/currentDutyStatusDirective/currentDutyStatusTemplate'}
get controller(){return CurrentDutyStatusDirectiveController}
get objectBindings(){return['personViewModel']}
get $inject(){return[]}};


const ControllerDefaults={
fullName:'Unknown',
highlight:!1,
abbreviation:'N/A'};


const HOSStatusDataMap=new Map([
[GeocodedStatus.Statuses.Driving,{
abbreviation:'D',
fullName:'Driving',
highlight:!0}],

[GeocodedStatus.Statuses.OnDuty,{
abbreviation:'ON',
fullName:'On Duty',
highlight:!0}],

[GeocodedStatus.Statuses.OffDuty,{
abbreviation:'OFF',
fullName:'Off Duty',
highlight:!1}],

[GeocodedStatus.Statuses.SleeperBerth,{
abbreviation:'SL',
fullName:'Sleeper Berth',
highlight:!1}],

[GeocodedStatus.Statuses.DrivingOffDuty,{
abbreviation:'OFF',
fullName:'Driving Off Duty',
highlight:!1}]]);let



CurrentDutyStatusDirectiveController=class CurrentDutyStatusDirectiveController{
constructor($scope,fatigueMeterTypeContentProviderService){
_.defaults(this,ControllerDefaults);

this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

$scope.$watch('controller.personViewModel',()=>this._updateVisibleStatus());

this._updateVisibleStatus();
}

_updateVisibleStatus(){
const result=tryGet(this,'personViewModel.currentHosStatus.value.status').
then(status=>HOSStatusDataMap.get(status)).
otherwise(this.personViewModel?_getHosStatusFromCurrentStatus(this.personViewModel,this._fatigueMeterTypeContentProviderService.fatigueMeterType):ControllerDefaults);

_.assign(this,result);

const currentThresholdStatus=_.get(this,'personViewModel.currentStatus.thresholdStatus');
this.isOverThreshold=currentThresholdStatus===ThresholdStatus.Above;
this.isAtThreshold=currentThresholdStatus===ThresholdStatus.At;
}};


const _getHosStatusFromCurrentStatus=(viewModel,fmType)=>{
if(fmType===FatigueMeterType.Aviation){
if(viewModel.currentStatus.onTrip||viewModel.currentStatus.onDuty){
return HOSStatusDataMap.get(GeocodedStatus.Statuses.OnDuty);
}
return HOSStatusDataMap.get(GeocodedStatus.Statuses.OffDuty);
}

if(viewModel.currentStatus.onTrip){
return HOSStatusDataMap.get(GeocodedStatus.Statuses.Driving);
}

if(viewModel.currentStatus.onDuty){
return HOSStatusDataMap.get(GeocodedStatus.Statuses.OnDuty);
}

return HOSStatusDataMap.get(GeocodedStatus.Statuses.OffDuty);
};

module.exports=CurrentDutyStatusDirective;
//# sourceMappingURL=currentDutyStatusDirective.js.map
